import { render, staticRenderFns } from "./BeneficiaryAddStepFour.vue?vue&type=template&id=e0b2f1be&scoped=true&"
import script from "./BeneficiaryAddStepFour.vue?vue&type=script&lang=js&"
export * from "./BeneficiaryAddStepFour.vue?vue&type=script&lang=js&"
import style0 from "./BeneficiaryAddStepFour.vue?vue&type=style&index=0&id=e0b2f1be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0b2f1be",
  null
  
)

export default component.exports